import React from 'react';
import { Form, Icon, Input, Button, Checkbox } from 'antd';
import { withRouter } from "react-router-dom";
import APPCONFIG from 'constants/appConfig';
import DEMO from 'constants/demoData';
import AuthService from "../../../../../services/authServices";
import { toast } from "react-toastify";
const FormItem = Form.Item;
toast.configure();

class NormalLoginForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      token: "",
      refreshToken: "",
      userDetail: "",
      role: "",
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const fingerPrint = localStorage.getItem("fingerPrint");
        const params = {
          email: values.email,
          password: values.password,
          fingerprint: fingerPrint,
          platform: "web",
        };
        AuthService.login(params)
          .then((response) => {
            if (response.status === 200) {
              this.setState({
                token: response.data.data.tokens.accessToken,
                refreshToken: response.data.data.tokens.refreshToken,
                userDetail: response.data.data.user,
                role: response.data.data.user.role.name,
              });
              if (response.data.data.user.role.name === "admin") {
                localStorage.setItem("token", response.data.data.tokens.accessToken);
                localStorage.setItem("refreshToken", response.data.data.tokens.refreshToken);
                this.props.userHandler(this.state.login, true);
                localStorage.removeItem("status");
                AuthService.setCurrentUser(response.data.data.user);
                toast.success("Login Successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000,
                });
              } else {
                toast.error("You are not authorized to login", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000,
                });
              }
            }
          })
          .catch((e) => {
            if (e.response.status !== undefined) {
              if (e.response.status === 400) {
                toast.error(e.response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 3000,
                });
              }
            }
          });
        this.props.history.push(DEMO.home2);
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <section className="form-card-page row no-gutters">
        <div className="card form-card__body offset-lg-3 p-5 px-lg-8 d-flex align-items-center mt-5 border-0">
          <section className="form-v1-container">
            <h2>Login to Continue</h2>
            <p className="lead">Welcome back, sign in with your {APPCONFIG.brand}</p>
            <Form onSubmit={this.handleSubmit} className="form-v1">
              <FormItem>
                {getFieldDecorator('email', {
                  rules: [{ required: true, type: "email", message: 'The input is not valid E-mail!' }],
                })(
                  <Input size="large" prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="Email" />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('password', {
                  rules: [{ required: true, message: 'Please input your Password!' },
                  { min: 8 }
                  ],
                })(
                  <Input size="large" prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="Password" />
                )}
              </FormItem>
              <FormItem className="form-v1__remember">
                {getFieldDecorator('remember', {
                  valuePropName: 'checked',
                  initialValue: true,
                })(
                  <Checkbox>Remember me</Checkbox>
                )}
              </FormItem>
              <FormItem>
                <Button type="primary" htmlType="submit" className="btn-cta btn-block">
                  Log in
                </Button>
              </FormItem>
            </Form>
            <p className="additional-info">Forgot your username or password? <a href={DEMO.forgotPassword}>Reset password</a></p>
          </section>
        </div>
      </section>
    );
  }
}

const Login = Form.create()(withRouter(NormalLoginForm));
export default Login;
